export default class {
    constructor (lodash, COMPANY_LANGUAGE_ENUM, NOTIFICATION_TRANSLATION_STATUS_ENUM) {
        this.lodash = lodash;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.NOTIFICATION_TRANSLATION_STATUS_ENUM = NOTIFICATION_TRANSLATION_STATUS_ENUM;
    }

    getTranslationStatusClasses (list) {
        this.lodash.forEach(list.items, (notification) => {
            notification.translationStatusClasses = [];
            this.lodash.forEach(notification.templateI18ns, (templateI18n) => {
                this.lodash.forEach(this.COMPANY_LANGUAGE_ENUM.KEYS, (language) => {
                    if (language === templateI18n.language.toUpperCase()) {
                        notification.translationStatusClasses[language] =
                            templateI18n.status === this.NOTIFICATION_TRANSLATION_STATUS_ENUM.KEYS.ACTIVE ?
                                'ico-check positive' : 'ico-cross fs-small muted';
                    }
                });
                const missingTranslations = this.lodash.difference(
                    this.lodash.toArray(this.COMPANY_LANGUAGE_ENUM.KEYS),
                    this.lodash.keys(notification.translationStatusClasses)
                );

                this.lodash.forEach(missingTranslations, (translationKey) => {
                    notification.translationStatusClasses[translationKey] = 'ico-cross fs-small muted';
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/notification/index.js